var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "96px",
  height: "96px",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Pencil_3406656",
  transform: "translate(-2.000000, 0.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M96.4,17.9 C94.5,14.8 92.1,11.8 89.2,8.9 C86.3,6 83.3,3.6 80.3,1.7 C77.4,-0.1 73.6,0.3 71.1,2.7 L13.4,60.3 C13.1,60.6 12.9,60.9 12.7,61.3 L2.7,89.7 C2.1,91.3 2.5,93 3.7,94.2 C4.5,95 5.6,95.5 6.7,95.5 C7.2,95.5 7.7,95.4 8.1,95.3 L36.5,85.3 C36.9,85.2 37.2,84.9 37.5,84.6 L95.3,27 C97.8,24.5 98.2,20.8 96.4,17.9 Z M17.3,65.2 C20.2,66.9 23.2,69.3 26,72.1 C28.8,74.9 31.1,77.9 32.8,80.8 L16.4,86.6 C15.9,85.6 15.2,84.6 14.4,83.8 C13.5,82.9 12.6,82.3 11.6,81.8 L17.3,65.2 Z",
  id: "Shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil.70a502ea939bc447bae87a3ddceb3e9f.svg";